/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';

import './CommandmentMessage.scss';

interface CommandmentMessageProps {
    action?: string;
    message: string;
    type?: string;
}

const CommandmentMessage: FunctionComponent<CommandmentMessageProps> = ({
    action,
    message,
    type,
}): JSX.Element => {
    return (
        <React.Fragment>
            <div className="cmd-msg-container">
                <div className="cmd-msg">{message}</div>
                {type && (
                    <div className={`cmd-act ${type}`} data-testid={`cmd-act-${type}`}>
                        {action}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

CommandmentMessage.propTypes = {
    action: PropTypes.string,
    message: PropTypes.string.isRequired,
    type: PropTypes.string,
};

export default CommandmentMessage;
